<template>
  <div class="animated fadeIn">
    <b-card no-header>
      <b-alert
        class="alert"
        :show="dismissCountDown"
        dismissible
        fade
        :variant="alertVariant"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged">
        <p>{{ alertMsj }}</p>
      </b-alert>             

      <b-form>
        <b-form-group>
          <b-form-radio v-model="cerrarAbrir" name="cerrarAbrir" :value="Boolean(true)">Cerrar y abrir</b-form-radio>

          <b-form-radio v-model="cerrarAbrir" name="cerrarTransferir" :value="Boolean(false)">Cerrar y transferir saldos</b-form-radio>
            <app-caja
              label="destino"
              :showLabel="false"
              :label-cols="labelCols"
              :nombre="cajaRegistroNombre"
              :lista="cajasRegistrosList"
              :readOnly="!seleccionarCaja"
              @updated="cajaRegistroActualizada">
            </app-caja>  
        </b-form-group>
      </b-form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Cerrar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Caja from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'CajaCierre',
  components: {
    appCaja: Caja,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    cajaRegistroId: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      cerrarAbrir: true,
      cajaRegistroNombre: null,
      cajasRegistros: [],
      cajasRegistrosList: [],

      labelCols: 2,
      alertCountDown: 15, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: ''
    }
  },
  computed: {
    seleccionarCaja() {
      return !this.cerrarAbrir;
    }
  },
  created() {
    this.getCajas();
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    getCajas() {
      const vm = this;
      vm.$store.dispatch('cajasregistros/getCajasRegistrosSelect')
        .then(() => {
          vm.cajasRegistros = this.$store.getters['cajasregistros/cajasRegistrosSelect'];
          vm.cajasRegistrosList = this.$store.getters['cajasregistros/cajasRegistrosSelectList'];
        })
        .catch(() => this.showAlert('Se produjo un error al recuperar la información de cajas disponibles.', 'danger'));
    },
    save () {
      let save = Boolean(true);
      let cajaRegistroDestino = 0;

      if (!this.cerrarAbrir) {
        let cajaRegistro = null;
        if (this.cajaRegistroNombre) {
          cajaRegistro = this.getSelected(this.cajasRegistros, this.cajaRegistroNombre);
        }

        let cajaRegistroError = true;
        if (cajaRegistro) {
          if (cajaRegistro.id) {
            if (cajaRegistro.id != 0) {
              cajaRegistroError = false;
            }
          }
        }
        if (cajaRegistroError) {
          save = Boolean(false);
          this.showAlert('Debe seleccionar la caja a la cual transferir los fondos de la caja actual.', 'danger')
        } else if (cajaRegistro.id == this.cajaRegistroId) {
          save = Boolean(false);
          this.showAlert('Debe seleccionar una caja distinta a la actual para transferir los fondos.', 'danger')
        } else {
          cajaRegistroDestino = cajaRegistro.id;
        }
      }

      if (save) {
        let params = {
          cajaRegistroOrigen: this.cajaRegistroId,
          cajaRegistroDestino
        }

        this.showSpinner();
        this.$store.dispatch('cajasregistros/cerrarCaja', params)
          .then(() => this.showModalMsj ('La caja se cerró con éxito.', this.close.bind(this, true), this.close.bind(this, true), 'light'))
          .catch(error => this.showAlert(error, 'danger'))
          .finally(() => this.hideSpinner());
      }
    },
    close(cajaCerrada) {
      this.$emit('close', cajaCerrada);
    },
    cajaRegistroActualizada(nombre) {
      this.cajaRegistroNombre = nombre;
    },
  },
  watch: {
  },
}
</script>

<style scoped>
  div.custom-radio:nth-child(2) {
    margin-top: 20px;
    margin-bottom: 10px;
  }
</style>
